<template>
  <!--
      描述：组件-选择课件（多选，弹窗列表，分页）
  -->
  <el-dialog
    title="选择课件"
    :visible.sync="dialogVisible"
    @close="cancelFunc"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="880px"
  >
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="课件名称">
          <el-input
            v-model="formInline.name"
            placeholder="请输入课件名称"
            style="width: 200px;"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" @click="search">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table
          :data="tableData"
          size="small"
          border
          style="width: 100%"
          v-loading="loading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column prop="name" label="课件名称" min-width="140"></el-table-column>
          <el-table-column label="课件封面" width="100">
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.cover_img"
                :src="scope.row.cover_img"
                fit="cover"
                style="width: 60px; height: 45px; border-radius: 4px;"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline" style="font-size: 18px;"></i>
                </div>
              </el-image>
              <span v-else style="color: #909399;">暂无封面</span>
            </template>
          </el-table-column>
          <el-table-column prop="ma_organization_name" label="所属组织" width="120"></el-table-column>
          <el-table-column prop="courseware_category_name" label="课件分类" width="120"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="cancelFunc">取 消</el-button>
      <el-button size="small" type="primary" @click="confirmFunc">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import CoursewareApi from '@/api/courseware.js';

export default {
  data() {
    return {
      loading: true,
      curPage: 1,
      pageSize: 15,
      totalDataNumber: 0,
      formInline: {
        name: ''
      },
      tableData: [],
      multipleSelection: [],
      dialogVisible: false
    };
  },
  props: {
    is_open: Boolean
  },
  watch: {
    is_open: function(n, o) {
      if (n !== o) {
        this.dialogVisible = n;
        if (n) {
          this.getTableList();
        }
      }
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    getTableList() {
      let self = this;
      self.loading = true;
      let apiParams = {
        name: self.formInline.name || undefined,
        page: self.curPage,
        list_rows: self.pageSize
      };
      Object.keys(apiParams).forEach(key => {
        if (apiParams[key] === '' || apiParams[key] === null || apiParams[key] === undefined) {
          delete apiParams[key];
        }
      });
      CoursewareApi.list(apiParams, true)
        .then(data => {
          self.loading = false;
          if (data.code === 1) {
            self.tableData = data.data.list.data || [];
            self.totalDataNumber = data.data.list.total || 0;
          } else {
            self.$message.error(data.msg || '获取课件列表失败');
          }
        })
        .catch(error => {
          self.loading = false;
          self.$message.error('获取课件列表失败，请稍后重试');
        });
    },
    search() {
      this.curPage = 1;
      this.getTableList();
    },
    confirmFunc() {
      let params = this.multipleSelection;
      this.emitFunc(params);
    },
    cancelFunc() {
      this.emitFunc();
    },
    emitFunc(e) {
      this.dialogVisible = false;
      if (e && typeof e !== 'undefined' && e.length > 0) {
        this.$emit('close', {
          type: 'success',
          params: e
        });
      } else {
        this.$emit('close', {
          type: 'error'
        });
      }
    },
    handleSelectionChange(e) {
      this.multipleSelection = e;
    }
  }
};
</script>

<style scoped>
.pagination {
  margin-top: 16px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/courseware/GetCourseware.vue